import { render, staticRenderFns } from "./doctorEchart.vue?vue&type=template&id=66646b94"
import script from "./doctorEchart.vue?vue&type=script&lang=js"
export * from "./doctorEchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports